// import ur1 from "../../assets/ur1.png";
import { useContext, useEffect, useState } from "react";
import "react-dropdown/style.css";
import { FaCheck, FaChevronDown, FaCog, FaImages, FaMapMarkerAlt, FaRegClipboard, FaRegClock, FaRegFile, FaRegUser } from "react-icons/fa";
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from "react-router-dom";
import styled from "styled-components";
import ur1 from "../assets/ur1.png";
import { fetchLocations, selectActiveLocation, selectLocations, setActive } from "../common/slices/location";
import theme from "../common/theme";
import { pathNames } from "../constants";
import { ErrorContext } from "../ErrorContext";
import { DropdownContainer, DropdownContent, DropdownItem } from "./Dropdown";
import { P } from "./Typography";
import Notifications from "./Notifications";


const Nav = styled.nav`
    display: flex;
    flex-direction: row;
    padding: 0 1rem;
    box-shadow: 0px 4px 13px 0px rgba(0, 0, 0, 0.1);
    z-index: 10;
    user-select: none;
`

const Logo = styled.img`
    height: 65px;
    padding: 1rem 0;
`

const HeaderContainer = styled.div`
    display: flex;
    flex-direction: row;    
    flex: 1;
`

const HeaderButton = styled(Link)`
    font-weight: 700;
    font-size: 16px;
    text-decoration: none;
    align-items: center;
    justify-content: center;
    display: flex;
    flex: 1;
    gap: 0.5rem;
    padding: 1rem;
    border-bottom-style: solid;
    border-bottom-width: 0.25rem;
    border-bottom-color: ${props => props.$active === true ? '#000' : '#d9d9d9'};
    color: #000;

    &:active, &:visited {
        color: inherit;
    }
`

const HeaderIconButton = styled(Link)`
    font-weight: 700;
    font-size: 16px;
    text-decoration: none;
    align-items: center;
    justify-content: center;
    display: flex;
    gap: 0.5rem;
    padding: 1rem;
    border-bottom-style: solid;
    border-bottom-width: 0.25rem;
    border-bottom-color: transparent;
    color: #000;
    user-select: none;


    &:active, &:visited,  {
        color: inherit;
    }
`

const Name = styled.span`
    flex: 1;
`

const Location = styled(P)`
    color: ${theme.palette.dark};
    vertical-align: middle;
    display: flex;
    align-items: baseline;
`

const TopNavSelectCompany = () => {
    const errorContext = useContext(ErrorContext);
    const dispatch = useDispatch();
    const [visible, setVisible] = useState(false);
    const locations = useSelector(selectLocations);
    const activeLocation = useSelector(selectActiveLocation);

    useEffect(() => {
        (async () => {
            try {
                await dispatch(fetchLocations);
            } catch (ex) {
                errorContext.setError({ errorMessage: "Failed to get locations from server.", forSupport: ex.message });
            }
        })()
    }, [dispatch])

    const onCompanySelect = (location) => {
        dispatch(setActive(location.id));
        setVisible(false);
    }

    return (
        <DropdownContainer>
            <Location onClick={() => setVisible(!visible)}>
                <FaMapMarkerAlt style={{ fontSize: 16, marginRight: '0.5rem' }} color="black" />
                {activeLocation?.name}
                <FaChevronDown style={{ marginLeft: '1rem', fontSize: 12 }} color="inherit" />
            </Location>
            <DropdownContent style={{ display: visible ? 'block' : 'none' }}>
                {locations.map(location => (
                    <DropdownItem onClick={() => onCompanySelect(location)} key={location.id}>
                        <Name>{location.name}</Name>{location.id === activeLocation?.id && <FaCheck />}
                    </DropdownItem>
                ))}
            </DropdownContent>
        </DropdownContainer>
    )
}

const TopNav = ({ visible = false }) => {
    const loc = useLocation();

    if (!visible) {
        return null;
    }

    return (
        <Nav>
            <HeaderContainer>
                <Logo src={ur1} />
            </HeaderContainer>
            <HeaderContainer style={{ flex: 2, justifyContent: 'stretch' }}>
                <HeaderButton to={pathNames.SAFETYFORMS} $active={loc.pathname.indexOf(pathNames.SAFETYFORMS) > -1}><FaRegClipboard style={{ fontSize: 16 }} /> Safety Forms</HeaderButton>
                <HeaderButton to={pathNames.TIMESHEETS} $active={loc.pathname.indexOf(pathNames.TIMESHEETS) > -1}><FaRegClock style={{ fontSize: 16 }} /> Time Sheets</HeaderButton>
                <HeaderButton to={pathNames.DAILYREPORT} $active={loc.pathname.indexOf(pathNames.DAILYREPORT) > -1}><FaRegFile style={{ fontSize: 16 }} /> Reports</HeaderButton>
                <HeaderButton to={pathNames.IMAGES} $active={loc.pathname.indexOf(pathNames.IMAGES) > -1}><FaImages style={{ fontSize: 16 }} /> Images</HeaderButton>
                <HeaderButton to={pathNames.USERS} $active={loc.pathname.indexOf(pathNames.USERS) > -1}><FaRegUser style={{ fontSize: 16 }} /> Users</HeaderButton>
            </HeaderContainer>
            <HeaderContainer style={{ justifyContent: 'flex-end' }}>
                <TopNavSelectCompany />
                <HeaderIconButton to={pathNames.SETTINGS} $active={loc.pathname.indexOf(pathNames.SETTINGS) > -1}><FaCog style={{ fontSize: 16 }} /> </HeaderIconButton>
                <Notifications />
                {/* <HeaderIconButton to={pathNames.NOTIFICATIONS} $active={loc.pathname.indexOf(pathNames.SETTINGS) > -1}><FaBell style={{ fontSize: 16 }} /> </HeaderIconButton> */}
            </HeaderContainer>
        </Nav>
    )
}
export default TopNav;
